package com.clany.backoffice.domain.usecase

import com.clany.backoffice.domain.repository.DashboardRepository
import com.clany.backoffice.model.DashboardMetrics

import dev.zacsweers.metro.Inject

@Inject
class GetDashboardMetricsUseCase(
    private val dashboardRepository: DashboardRepository
) {
    suspend operator fun invoke(): Result<DashboardMetrics> {
        return dashboardRepository.getMetrics()
    }
}
